import React from "react";

export default function ExampleDownloadButton({ paid, className = "" }) {
  if (paid) return null;
  return (
    <a
      href="/example.pdf"
      download
      className={`h-11 rounded-lg bg-gray-500 px-5 text-white font-semibold shadow hover:bg-gray-600 inline-flex items-center justify-center ${className}`}
    >
      Скачать пример
    </a>
  );
}
